import React, { useState } from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

import { Row, TwoThird } from "../layout/container"
import List from "../ui/list"
import { GatsbyImage } from "gatsby-plugin-image";
import Sidemenu from "../layout/sidebar"

const Section = styled.section`
  //padding: 5rem 0 1rem;
  min-height: 65vh;

  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 3rem 0 0;

    form {
      margin-top: 2rem;
    }
  }

  h2 {
    color: ${props => props.theme.colors.primary};
    font-size: 50px;
    text-align: center;
    margin: 0 0 3rem;
  }

  p {
    margin-top: 0;
  }

  .visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  input,
  select {
    display: block;
    width: 100%;
    font-size: 1rem;
    padding: 7px 11px;
    box-sizing: border-box;
    font-family: ${(props) => props.theme.fontCondensed};
    margin-bottom: 1rem;
    border-radius: 0;
  }
  

  button {
    //width: 100%;
    font-size: 16px;
    padding: 7px 11px;
    font-family: ${props => props.theme.font};
    background: ${props => props.theme.colors.primary};
    border: none;
    display: block;
    //margin: 0 auto;
    &:hover {
      background: lighten(${props => props.theme.colors.white}, 10%);
    }
  }
`

const Submit = styled(`button`)`
  //border:1px solid rgba(220, 70, 84, 0.6);
  border-left: none;
  border-radius: 20px;
	display:inline-block;
  cursor:pointer; 
  width: 150px;
	color: ${(props) => props.theme.colors.white};
  padding: 0.5rem 1rem;
  text-decoration:none;
  background-color: ${(props) => props.theme.colors.primary};
  font-family: ${(props) => props.theme.fontCondensed};
  //margin-top: 1rem;
  :focus {
   
    outline: 0;
  
  }
`

const SingleLineInput = styled(`input`)`

  padding: 0.5rem 1rem;
  border-width: 1px;
  border-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.primary};
  border-style: solid;
  border-radius: 0px;
  background-color : ${(props) => props.theme.colors.white}; 
  width: 50%;
  font-family: ${(props) => props.theme.fontCondensed};
  :focus {
   
    outline: 0;
  
  }
    ::placeholder {
    color: ${(props) => props.theme.colors.primary};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${(props) => props.theme.colors.primary};
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: ${(props) => props.theme.colors.primary};
  }
`

const MultiLineInput = styled(`textarea`)`
  font-size: 1rem;
  padding: 7px 11px;
  background-color : ${(props) => props.theme.colors.white}; 
  border-width: 1px;
  resize: vertical;
  border-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.primary};
  border-style: solid;
  border-radius: 0px;
  font-family: ${(props) => props.theme.fontCondensed};
  min-width: -webkit-fill-available;
  margin-bottom: 1rem;
  :focus {
    outline: 0;
  }
  ::placeholder {
    color: ${(props) => props.theme.colors.primary};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${(props) => props.theme.colors.primary};
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: ${(props) => props.theme.colors.primary};
  }
`

const Container = styled.div`
  width: 680px;
  max-width: 90%;
  margin: 0 auto;
`

const Success = styled.div`
  background: ${props => props.theme.colors.light};
  padding: 1rem;
  box-sizing: border-box;
`

const Error = styled.div`
  background: #ecdcdc;
  padding: 1rem;
  box-sizing: border-box;
`

const LocationHireForm = () => {
  const data = useStaticQuery(graphql`{
  file(relativePath: {eq: "market-arch.jpeg"}) {
    childImageSharp {
      gatsbyImageData(width: 700, layout: CONSTRAINED)
    }
  }
}
`)
  const [sent, send] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const [firstName, setFirstName] = useState<string>("")
  const [lastName, setLastName] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [phone, setPhone] = useState<string>("")
  const [company, setCompany] = useState<string>("")
  const [message, setMessage] = useState<string>("")

  const encode = (data: any) => {
    return Object.keys(data)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
      .join("&")
  }

  const clearForm = () => {
    setFirstName("")
    setLastName("")
    setEmail("")
    setPhone("")
    setCompany("")
    setMessage("")
  }

  function handleSubmit(e: any) {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        email,
        phone,
        company,
        message,
        "form-name": "location-hire",
        first_name: firstName,
        last_name: lastName,
      }),
    })
      .then(() => {
        send(true)
        clearForm()
      })
      .catch(err => setError(err))

    e.preventDefault()
  }

  return (
    <Section id="contact">

              {error && <Error>Please fill in all the fields of the form!</Error>}
              {sent ? (
                <Success>Thanks for contacting us. We’ll get back to you as soon as we can.</Success>
              ) : (
                <form
                  name="location-hire"
                  method="post"
                  action="/#contact"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  onSubmit={e => handleSubmit(e)}
                >
                  <input type="hidden" name="form-name" value="location-hire" />
                  <input type="hidden" name="bot-field" />
                  <label htmlFor="first_name" className="visuallyhidden">
                    First name
                  </label>
                  <SingleLineInput
                    className="input"
                    type={"text"}
                    name={"first_name"}
                    id={"first_name"}
                    placeholder={"First name"}
                    required={true}
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                  />
                  <label htmlFor="last_name" className="visuallyhidden">
                    Last name
                  </label>
                  <SingleLineInput
                    className="input"
                    type={"text"}
                    name={"last_name"}
                    id={"last_name"}
                    placeholder={"Last name"}
                    required={true}
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                  />
                  <label htmlFor="company" className="visuallyhidden">
                    Company
                  </label>
                  <SingleLineInput
                    className="input"
                    type={"text"}
                    name={"company"}
                    id={"company"}
                    placeholder={"Company"}
                    required={true}
                    value={company}
                    onChange={e => setCompany(e.target.value)}
                  />
                  <label htmlFor="email" className="visuallyhidden">
                    Email
                  </label>
                  <SingleLineInput
                    className="input"
                    type={"email"}
                    name={"email"}
                    id={"email"}
                    placeholder={"Email"}
                    required={true}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                  <label htmlFor="telephone" className="visuallyhidden">
                    Telephone
                  </label>
                  <SingleLineInput
                    className="input"
                    type={"text"}
                    name={"phone"}
                    id={"phone"}
                    placeholder={"Telephone"}
                    required={true}
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                  />
                  <label htmlFor="message" className="visuallyhidden">
                    Message
                  </label>
                  <MultiLineInput
                    className="input"
                    type={"textarea"}
                    name={"message"}
                    id={"message"}
                    placeholder={"Details of your request"}
                    required={true}
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                  />
                  <Submit type="submit">Send</Submit>
                </form>
              )}

    </Section>
  )
}

export default LocationHireForm
